import _join from 'lodash/join';
import _map from 'lodash/map';
import _get from 'lodash/get';
import _find from 'lodash/find';
import { EMPTY_STRING } from '../app.constants';
export var DEFAULT_PHONE_CODE = '+1';
export var getFormattedPhoneNum = function getFormattedPhoneNum(input) {
  var flag1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var flag2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var output = '(';
  if (!input) return input;
  input.replace(/^\D*(\d{0,3})\D*(\d{0,3})\D*(\d{0,4})/, function (match, g1, g2, g3) {
    if (g1.length) {
      output += g1;

      if (g1.length === 3) {
        if (flag1) output += ')';

        if (g2.length) {
          output += " ".concat(g2);

          if (g2.length === 3) {
            if (flag2) output += ' - ';

            if (g3.length) {
              output += g3;
            }
          }
        }
      }
    }
  });
  return output === '(' ? '' : output;
};
export var getPhoneNo = function getPhoneNo(data) {
  if (data && data !== '(') {
    return _join(data.match(/\d/g), '');
  }

  return null;
};
export var flagChecker = function flagChecker(prevPhoneNo, phoneNumber) {
  var flag1 = true;
  var flag2 = true;
  var formattedPhoneNumber = getPhoneNo(phoneNumber);
  var formattedPrevPhoneNo = getPhoneNo(prevPhoneNo);

  if (prevPhoneNo && phoneNumber && prevPhoneNo.length > phoneNumber.length && formattedPhoneNumber === formattedPrevPhoneNo) {
    if (formattedPhoneNumber.length === 6) {
      flag2 = false;
    } else if (formattedPhoneNumber.length === 3) {
      flag1 = false;
    }
  }

  return {
    flag1: flag1,
    flag2: flag2,
    formattedPhoneNumber: formattedPhoneNumber
  };
};
export var getPhoneNumberFromApi = function getPhoneNumberFromApi(number, code) {
  return {
    phoneCode: code || DEFAULT_PHONE_CODE,
    phoneNumber: getFormattedPhoneNum(number)
  };
};
export var getCountryPhoneCodesOptions = function getCountryPhoneCodesOptions(countriesData) {
  return _map(countriesData, function (country) {
    var phoneCode = _get(country, 'phoneCountryCode', EMPTY_STRING);

    return {
      label: phoneCode,
      value: phoneCode
    };
  });
};
export var getDefaultPhoneCode = function getDefaultPhoneCode(countries, countryCode) {
  var country = _find(countries, function (item) {
    return item.twoDigitCountryCode === countryCode;
  });

  return _get(country, 'phoneCountryCode', DEFAULT_PHONE_CODE);
};